module.exports = __webpack_public_path__ + "static/media/BarrelCash.21211e9b.png";